import React, { useState, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Tabs, Tab, Grid, Grow, Typography } from "@mui/material";
import MyContext from "../../../contexts/MyContext";
import { lngs, TicketType } from "../../../Constant";
import { SingleTicketForm1 } from "../single-ticket-forms/SingleTicketForm1";
import { CommuterTicketForm1 } from "../commuter-ticket-forms/CommuterTicketForm1";

export const Slide1 = (props) => {
  const { t, i18n } = useTranslation();
  const myContext = useContext(MyContext);
  // const [tabIndex, setTabIndex] = useState(myContext.ticketType);

  // useEffect(() => {
  //   myContext.resetState();
  //   myContext.changeTicketType(tabIndex);
  // }, [tabIndex]);

  return (
    <MyContext.Consumer>
      {(context) => (
        <div hidden={context.activeSlide !== 0}>
          <Grow in={true} className="margin left-1 right-1">
            <Tabs
              centered
              indicatorColor="primary"
              variant="fullWidth"
              textColor="primary"
              value={context.ticketType}
              onChange={(e, value) => context.changeTicketType(value)}
            >
              <Tab label={t("movingo")} value={TicketType.COMMUTER} />
              <Tab label={t("single_ticket")} value={TicketType.SINGLE} />
            </Tabs>
          </Grow>
          <div role="tabpanel" hidden={context.ticketType !== TicketType.COMMUTER}>
            <CommuterTicketForm1 {...props} />
          </div>
          <div role="tabpanel" hidden={context.ticketType !== TicketType.SINGLE}>
            <SingleTicketForm1 {...props} />
          </div>
          <Grid container justifyContent="center" spacing={2}>
            {Object.keys(lngs).map((lng) => (
              <Grid item key={lng}>
                <Typography
                  className="selector"
                  variant="overline"
                  display="block"
                  gutterBottom
                  onClick={() => i18n.changeLanguage(lng)}
                  style={{ fontWeight: i18n.language === lng ? "bold" : "normal" }}
                >
                  {lngs[lng].nativeName}
                </Typography>
              </Grid>
            ))}
          </Grid>
        </div>
      )}
    </MyContext.Consumer>
  );
};
